import { Pipe, PipeTransform } from "@angular/core";
import { StranaZustatku, TypUctu } from "../enums/enums";

@Pipe({
    name: 'fromIntToEnum',
    standalone: false
})
export class FromIntToEnumPipe implements PipeTransform {
    transform(value: any, ...args: any[]) {
        switch(args[0]){
            case 0:
                return TypUctu[value];
            case 1:
                return StranaZustatku[value];
        }
        return "";
    }
}